import { HttpClient } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { POPreference } from '~/models/administration/poPreference';
import { ApiServiceBase, API_NAMES } from '../api';

@Injectable({ providedIn: 'root' })
export class POPreferencesService extends ApiServiceBase {
    constructor(injector: Injector, private http: HttpClient) {
        super(injector);
        this.setBase(API_NAMES.adminStock);
    }

    getPOPreference() {
        return this.http.get<POPreference>(this._url());
    }

    createPOPreference(model: any) {
        return this.client.post(this._url(), model);
    }

    updatePOPreference(model: any) {
        return this.client.put(this._url(), model);
    }

    private _url(v?: string | undefined) {
        v = v || '';
        return this.url(`/POPreferences${v}`);
    }
}
